import * as React from 'react';

import type { Stock } from '../../output/models';

import { AllServiceLinks } from '../../components/ServiceLink';
import { FavoriteIcon } from '../../components/FavoriteIcon';

import { operatingIncomeRatio, per, pbr, ytd, textRed } from '../../utils';

interface Props {
  code: string;
  stock: Stock | undefined;
}

export const Header: React.FC<Props> = ({ code, stock }) => {
  return (
    <div className="flex flex-wrap items-baseline gap-1.5 gap-y-0.5 text-xs">
      <h2 className="inline gap-1.25 text-lg md:flex md:items-center">
        <span className="mr-1.25 font-medium md:mr-0">{code}</span>
        <span>{stock?.name}</span>
        <span className="ml-1 md:ml-0 md:flex md:items-center">
          <FavoriteIcon stock={stock} />
        </span>
      </h2>
      <span className="mr-0.75 flex gap-2 text-sm leading-base md:text-ssm">
        <span>{per(stock)}</span>
        <span>{pbr(stock)}</span>
        <span>{operatingIncomeRatio(stock)}</span>
        <span className={textRed(stock?.ytd)}>{ytd(stock)}</span>
      </span>
      <AllServiceLinks className={'text-ssm md:text-xs'} code={code} />
    </div>
  );
};
